const style = (theme) => {
  const output = {
    root: {
      opacity: 0,
      overflow: 'hidden',
      maxWidth: '100vw',
    },

    cursor: {
      position: 'fixed',
      zIndex: 10,
      marginLeft: -8,
      marginTop: -20,
      transformOrigin: 'center',
      transition: 'transform .3s ease-in-out, opacity .3s ease-in-out',
      pointerEvents: 'none',
      opacity: 0,
      '&.visible': {
        opacity: 1,
      },
      '&.prev': {
        transform: 'rotate(180deg)',
      },
      '& svg': {
        width: 16,
        height: 10,
        fill: theme.colors[1],
      },
    },

    // Carousel
    gallery: {
      width: '100vw',
      maxHeight: '100vh',
      display: 'flex',
    },
    thumbnails: {
      width: 85,
      maxHeight: '100vh',
      overflowY: 'auto',
    },
    pagination: {
      width: 85,
      display: 'flex',
      alignItems: 'flex-end',
      textAlign: 'center',
      padding: 14,
      color: theme.colors[1],
      justifyContent: 'center',
      fontSize: 12,
      position: 'absolute',
      bottom: 0,
      right: 0,
    },
    currentSlide: {
      display: 'inline-block',
    },
    thumb: {
      cursor: 'pointer',
      margin: 14,
      opacity: 0.4,
      transition: 'opacity .3s ease-out',
      '&.active': {
        opacity: 1,
      },
    },
    carouselWrap: {
      width: '100vw',
      cursor: 'pointer',
      '& img': {
        marginBottom: 14,
      },
      '& .slick-arrow': {
        width: '50%',
        height: '100%',
        zIndex: 10,
        fontSize: 0,
        '&:before': {
          display: 'none',
        },
      },
      '& .slick-prev': {
        left: 0,
        background: 'transparent',
      },
      '& .slick-next': {
        right: 0,
      },
      '& .slick-track': {
        display: 'flex',
      },
      '& .slick-slide': {
        height: '100vh',
        maxHeight: '100vh',
      },
      '& .slick-active': {
        '& $carouselImg': {
          '& img': {
            transform: 'scale(1)',
            opacity: 1,
          },
        },
      },
    },
    galleryItem: {
      width: '100%',
      height: '100vh',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      position: 'relative',
      zIndex: 1,
      opacity: 0,
      transition: 'transform .8s cubic-bezier(0.25, 0.39, 0.25, 1), opacity .8s cubic-bezier(0.25, 0.39, 0.25, 1)',
      transform: 'scale(1.05)',
      '.slick-active &': {
        opacity: 1,
        transform: 'scale(1)',
      },
    },
    galleryImg: {
      width: '100%',
      height: '100vh',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
    galleryCaption: {
      position: 'absolute',
      zIndex: 1,
      bottom: 0,
      left: 0,
      width: '100%',
      padding: '6px 14px',
      color: theme.colors[1],
      background: theme.getRgba(theme.colors[0], 0.7),
      display: 'none',
    },


  }


  return output
}

export default style
